import { makeStyles } from '@material-ui/core/styles'

const historyAlertLinkColor = (theme) =>
  theme.palette.type === 'dark' ? theme.palette.components.linkText : '#0F61E6'

export const myAlertsStyles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    width: 335,
    overflowY: 'clip',
    overflowX: 'hidden',
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  retainer: {
    height: '100%',
  },
  modalTabs: {
    width: '335px',
    height: '35px',
    minHeight: '35px',
    minWidth: '335px',
    [theme.breakpoints.down(400)]: {
      width: '300px',
    },
  },
  alertsListContainer: {
    padding: theme.spacing(0.5),
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  alertsListContainerHistory: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  alertsHistoryDialogContentBg: {
    backgroundColor: theme.palette.paper.secondary,
    width: '45vw',
    maxWidth: '100%',
    height: '70dvh',
    padding: '0px',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px',
      width: '90vw',
      height: '60dvh',
    },
  },
  alertsHistoryDialogContentWrapper: {
    width: '100%',
    height: '100%',
    minHeight: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  alertsHistoryCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(1.5, 1),
    boxSizing: 'border-box',
    scrollbarWidth: 'thin',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  alertsHistoryCard: {
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: theme.shadows[2],
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    width: '100%',
    backgroundColor: theme.palette.paper.primary,
  },
  alertsHistoryCardHeader: {
    backgroundColor: '#cc0033',
    color: '#fff',
    padding: theme.spacing(1.5),
    borderRadius: '12px 12px 0 0',
    '& h6': {
      fontWeight: 700,
      lineHeight: 1.3,
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
    },
  },
  alertsHistoryCardBody: {
    padding: theme.spacing(1, 1.5, 1),
  },
  alertsHistoryDateRow: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontWeight: 400,
  },
  alertsHistoryMessage: {
    marginBottom: theme.spacing(1),
  },
  alertsHistoryLinkRow: {
    marginTop: theme.spacing(0.5),
  },
  alertsHistoryLink: {
    color: historyAlertLinkColor(theme),
    textDecoration: 'underline',
    wordBreak: 'break-all',
  },
  descriptionStyle: {
    marginTop: 0,
    marginBottom: 0,
    '& p': { margin: '0 0 0.5em 0' },
    '& a': {
      color: historyAlertLinkColor(theme),
      textDecoration: 'underline',
    },
  },
  alertsHistoryFooter: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(2, 1.5, 1.5),
    borderTop: `1px solid ${
      theme.palette?.base?.lightGray || theme.palette?.divider || '#e0e0e0'
    }`,
  },
  alertsHistoryFooterItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  alertListHeight: {
    display: 'block',
    height: 391,
    maxHeight: 391,
    overflowY: 'auto',
    borderBottom: `1px solid ${theme.palette.base.lightGray}`,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 283px)',
    },
  },
  alertListHighChip: {
    background: '#cc0033',
    color: '#fff',
    fontSize: '1rem',
    '&:hover': {
      background: '#cc0033',
    },
  },
  alertListMediumChip: {
    background: '#0F61E6',
    color: '#fff',
    fontSize: '1rem',
    '&:hover': {
      background: '#0F61E6',
    },
  },
  alertListLowChip: {
    background: '#F9C642',
    color: '#000',
    fontSize: '1rem',
    '&:hover': {
      background: '#F9C642',
    },
  },
  alertsHistoryHighChip: {
    background: '#cc0033',
    color: '#fff',
    fontSize: '0.75rem',
    height: 22,
    '&:hover': {
      background: '#cc0033',
    },
  },
  alertsHistoryMediumChip: {
    background: '#0F61E6',
    color: '#fff',
    fontSize: '0.75rem',
    height: 22,
    '&:hover': {
      background: '#0F61E6',
    },
  },
  alertsHistoryLowChip: {
    background: '#F9C642',
    color: '#000',
    fontSize: '0.75rem',
    height: 22,
    '&:hover': {
      background: '#F9C642',
    },
  },
  fullWidth: {
    maxWidth: '100% !important',
  },
  pastHistoryButton: {
    width: 'calc(100% - 8px)',
    background: theme.palette.base.red,
    color: theme.palette.base.white,
    height: 44,
    fontSize: '1rem',
    margin: theme.spacing(0.5),
  },
  icon: {
    borderLeft: '5px solid red',
  },
}))

export default myAlertsStyles
